class MyDeliverySaverPaymentMethodController {
    constructor($state, myDeliverySaverService, settings) {
        this.$state = $state;
        this.myDeliverySaverService = myDeliverySaverService;
        this.settings = settings;
    }

    $onInit() {
        this.loading = false;
        this.isRetrySuccess = false;
        this.isRetryAttempted = false;

        this.lastPayment = this.myDeliverySaverService.lastPayment;
        this.isPaymentFailure = this.lastPayment
            && this.lastPayment.Status === 'Failure'
            && this.subscription.Status === 'Suspended';
    }

    retryPayment() {
        this.loading = true;
        this.isRetryAttempted = false;

        this.myDeliverySaverService.retryPayment()
            .then(() => {
                this.isRetrySuccess = true;
                this.isPaymentFailure = false;
            })
            .catch(() => {
                this.isRetrySuccess = false;
            })
            .finally(() => {
                this.loading = false;
                this.isRetryAttempted = true;
            });
    }
}

MyDeliverySaverPaymentMethodController.$inject = ['$state', 'MyDeliverySaverService', 'Settings'];

const MyDeliverySaverPaymentMethodComponentDefinition = {
    bindings: {
        subscription: '<',
    },
    controller: MyDeliverySaverPaymentMethodController,
    template: require('./my-delivery-saver-payment-method.component.html').trim(),
};

module.exports = {
    MyDeliverySaverPaymentMethodComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/mydeliverysaver/paymentmethod/my-delivery-saver-payment-method.component.js